var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn-outline-light",
        attrs: { title: "Show details" },
        on: {
          click: function ($event) {
            return _vm.openModal()
          },
        },
      },
      [_c("i", { staticClass: "fa-regular fa-eye" })]
    ),
    _vm._v(" "),
    _vm.isModalOpen
      ? _c("div", { staticClass: "modal-container" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("h1", [
              _vm._v("Order Details"),
              _c("i", {
                staticClass: "fa-regular fa-xmark",
                on: {
                  click: function ($event) {
                    return _vm.closeModal()
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  "font-weight": "normal",
                  color: "#717182",
                  "justify-content": "baseline",
                  display: "flex",
                },
              },
              [
                _vm._v(
                  "Order " +
                    _vm._s(
                      this.order.Invoices[0]
                        ? this.order.Invoices[0].InvoiceIdentifier
                        : ""
                    )
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  display: "grid",
                  "grid-template-columns": "1fr 1fr",
                  gap: "1rem",
                },
              },
              [
                _c("div", { staticStyle: { display: "grid", gap: "1rem" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "baseline",
                        "font-weight": "bold",
                        "font-size": "1.1rem",
                      },
                    },
                    [_vm._v("Order Information")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#6a7282" } }, [
                        _vm._v("Reference:"),
                      ]),
                      _vm._v(" "),
                      this.order.Invoices[0]
                        ? _c("span", [
                            _vm._v(
                              _vm._s(this.order.Invoices[0].InvoiceIdentifier)
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#6a7282" } }, [
                        _vm._v("Amount:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v(
                          "€" + _vm._s(Number(this.order.Amount).toFixed(2))
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#6a7282" } }, [
                        _vm._v("Outstanding:"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          style: {
                            color:
                              this.order.Amount > 0 ? "#f54a00" : "#00a63e",
                          },
                        },
                        [
                          _vm._v(
                            "€" + _vm._s(Number(this.order.Amount).toFixed(2))
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#6a7282" } }, [
                        _vm._v("Status:"),
                      ]),
                      _vm._v(" "),
                      this.order.Status == 0
                        ? _c(
                            "span",
                            {
                              staticClass: "btn-selection",
                              staticStyle: {
                                color: "#334155",
                                "background-color": "#f8fafc",
                                "border-color": "#e2e8f0",
                              },
                            },
                            [_vm._v("Created")]
                          )
                        : this.order.Status == 1
                        ? _c(
                            "span",
                            {
                              staticClass: "btn-selection",
                              staticStyle: {
                                "border-color": "#ffc9c9",
                                "background-color": "#ffe2e2",
                                color: "#9f0712",
                              },
                            },
                            [_vm._v("Not Reconciled")]
                          )
                        : this.order.Status == 2
                        ? _c(
                            "span",
                            {
                              staticClass: "btn-selection",
                              staticStyle: {
                                color: "rgb(161, 98, 7)",
                                "background-color": "rgb(254, 252, 232)",
                                "border-color": "rgb(254, 240, 138)",
                              },
                            },
                            [_vm._v("Partially Paid")]
                          )
                        : this.order.Status == 3
                        ? _c(
                            "span",
                            {
                              staticClass: "btn-selection",
                              staticStyle: {
                                "border-color": "rgb(185, 248, 207)",
                                "background-color": "rgb(240, 253, 244)",
                                color: "rgb(0, 130, 54)",
                              },
                            },
                            [_vm._v("Reconciled")]
                          )
                        : _c("span", [_vm._v("—")]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { display: "grid", gap: "1rem" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "baseline",
                        "font-weight": "bold",
                        "font-size": "1.1rem",
                      },
                    },
                    [_vm._v("Payment Details")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#6a7282" } }, [
                        _vm._v("VIBAN:"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            this.order.VIBAN == "$NotFound" ||
                              this.order.VIBAN == null
                              ? "—"
                              : this.order.VIBAN
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#6a7282" } }, [
                        _vm._v("Client Number:"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            this.order.Reference1 == ""
                              ? this.order.PaymentGroupIdentifier2
                              : this.order.Reference1
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#6a7282" } }, [
                        _vm._v("Payments:"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.nbPayments))]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#6a7282" } }, [
                        _vm._v("Reconciliations:"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.nbReconciled))]),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { "margin-top": "2rem" } }, [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "baseline",
                    "font-weight": "bold",
                    "font-size": "1.1rem",
                  },
                },
                [_vm._v("Timeline & Logs")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    gap: "1rem",
                    "margin-top": "1rem",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "grid",
                        gap: "0.35rem",
                        "justify-items": "center",
                      },
                    },
                    [
                      this.order.Status == 3
                        ? _c("i", {
                            staticClass: "fa-regular fa-clock",
                            staticStyle: {
                              "background-color": "#dbeafe",
                              color: "#155dfc",
                              "border-radius": "50%",
                              padding: "1rem",
                              "font-size": "1.25rem",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.order.Status == 3
                        ? _c("div", {
                            staticStyle: {
                              border: "1px solid #ebe6e7",
                              height: "2rem",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa-regular fa-triangle-exclamation",
                        staticStyle: {
                          "background-color": "#f6f3f4",
                          color: "#f54a00",
                          "border-radius": "50%",
                          padding: "1rem",
                          "font-size": "1.25rem",
                        },
                      }),
                      _vm._v(" "),
                      this.reconciliation &&
                      this.reconciliation.ReconciliationMode != 0
                        ? _c("div", {
                            staticStyle: {
                              border: "1px solid #ebe6e7",
                              height: "2rem",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.reconciliation &&
                      this.reconciliation.ReconciliationMode != 0
                        ? _c("i", {
                            staticClass: "fa-regular fa-circle-check",
                            staticStyle: {
                              "background-color": "#dcfce7",
                              color: "#00a63e",
                              "border-radius": "50%",
                              padding: "1rem",
                              "font-size": "1.25rem",
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "grid",
                        gap: "2rem",
                        width: "100%",
                      },
                    },
                    [
                      this.order.Status == 3
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("Payment Received")]
                                ),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      new Date(
                                        this.order.PaymentGroupDate
                                      ).toLocaleDateString()
                                    ) +
                                      " " +
                                      _vm._s(
                                        new Date(
                                          this.order.PaymentGroupDate
                                        ).toLocaleTimeString()
                                      )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c(
                                "span",
                                { staticStyle: { color: "#6a7282" } },
                                [
                                  _vm._v(
                                    "Payment of €" +
                                      _vm._s(
                                        Number(this.order.Amount).toFixed(2)
                                      ) +
                                      " received on VIBAN " +
                                      _vm._s(this.order.VIBAN)
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("Order Created")]
                            ),
                            _vm._v(" "),
                            this.order.Invoices[0]
                              ? _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      new Date(
                                        this.order.Invoices[0].InvoiceDate
                                      ).toLocaleDateString()
                                    ) +
                                      " " +
                                      _vm._s(
                                        new Date(
                                          this.order.Invoices[0].InvoiceDate
                                        ).toLocaleTimeString()
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c("span", { staticStyle: { color: "#6a7282" } }, [
                            _vm._v(
                              "Order " +
                                _vm._s(
                                  this.order.Invoices[0]
                                    ? this.order.Invoices[0].InvoiceIdentifier
                                    : ""
                                ) +
                                " created for €" +
                                _vm._s(Number(this.order.Amount).toFixed(2))
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      this.reconciliation &&
                      this.reconciliation.ReconciliationMode != 0
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("Payment Confirmed")]
                                ),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      new Date(
                                        this.reconciliation.PaymentGroupDate
                                      ).toLocaleDateString()
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticStyle: { display: "flex" } }, [
                              this.reconciliation.ReconciliationMode == 1
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#6a7282" } },
                                    [_vm._v("AUTO reconciliation")]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { color: "#6a7282" } },
                                    [_vm._v("Manual reconciliation")]
                                  ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.payments.length > 0
              ? _c(
                  "div",
                  { staticStyle: { "margin-top": "2rem" } },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "1.1rem",
                        },
                      },
                      [_vm._v("Payments")]
                    ),
                    _vm._v(" "),
                    _c("b-table", {
                      staticClass: "table-header-border rounded",
                      staticStyle: {
                        "margin-bottom": "0",
                        "margin-top": "1rem",
                      },
                      attrs: {
                        responsive: "",
                        hover: "",
                        rounded: "",
                        items: _vm.payments,
                        fields: _vm.fields,
                        "primary-key": "id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "cell(amount)",
                            fn: function (data) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    "\n                €" +
                                      _vm._s(
                                        Number(data.item.Amount).toFixed(2)
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "cell(status)",
                            fn: function (data) {
                              return [
                                data.item.Status == 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "btn-selection",
                                        staticStyle: {
                                          color: "#334155",
                                          "background-color": "#f8fafc",
                                          "border-color": "#e2e8f0",
                                        },
                                      },
                                      [_vm._v("Created")]
                                    )
                                  : data.item.Status == 1
                                  ? _c(
                                      "span",
                                      { staticClass: "btn-selection" },
                                      [_vm._v("Not Reconciled")]
                                    )
                                  : data.item.Status == 2
                                  ? _c("span", [_vm._v("Partially Reconciled")])
                                  : data.item.Status == 3
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "btn-selection",
                                        staticStyle: {
                                          "border-color": "#b9f8cf",
                                          "background-color": "#f0fdf4",
                                          color: "#008236",
                                        },
                                      },
                                      [_vm._v("Reconciled")]
                                    )
                                  : _c("span", [_vm._v("—")]),
                              ]
                            },
                          },
                          {
                            key: "cell(date)",
                            fn: function (data) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      new Date(
                                        data.item.CreationDate
                                      ).toLocaleString()
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1279228724
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }